import React from 'react';
import PropTypes from 'prop-types';

const Search = ({ width, className }) => (
  <svg
    width={width}
    height={width}
    className={className}
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
  >
    <circle cx="7.5" cy="7.5" r="5.75" stroke="currentColor" strokeWidth="1.5" />
    <path d="M12 12L16 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

Search.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

Search.defaultProps = {
  width: 18,
  className: '',
};

export default Search;
